import React from 'react';

import { Icon } from './styles';

type CoinIconType = {
  name: string;
  noMargin?: boolean;
};

const CoinIcon: React.FC<CoinIconType> = ({ name, noMargin }) => {
  return (
    <Icon style={{ marginRight: noMargin ? 0 : 20 }} src={'/images/coins/' + name.toLocaleLowerCase() + '-icon.png'} alt={name} />
  );
};

export default CoinIcon;
